import React, { Component } from 'react';
import { ResponsiveContainer, Legend, Bar, BarChart, XAxis, YAxis, CartesianGrid, Tooltip } from 'recharts';
import { connect } from "react-redux";
import { getVunnenChartByUserid,setofUpdatedashboard,decrypt,encrypt } from 'actions'
import {isEmpty,isUndefined} from 'lodash'
import {NumberFormat} from 'components/NotyNumberFormat'
import moment from 'moment'
import Skeleton from '@material-ui/lab/Skeleton';
import axios from 'util/ApiDashboard'
import IntlMessages from 'util/IntlMessages';
const renderColorfulLegendText = (value, entry) => {
  const { color } = entry;
  return <span style={{ color }}>{value}</span>;
}

class ForsaljningThisMonth extends Component {
  state={
    SummaVunnen:0,
    DashboardAnpassadFilterOption:[],
    done: true
  }
  intervalID = null

  componentDidMount=()=>{
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    axios.get(`kontos/DashBoard/getSUMVunnenMonth`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
       if(res.data.success){
                                   let endata = decrypt(res.data.encryptedData,res.data.iv)
                                   let ndate = JSON.parse(endata)
                                   this.setState({ 
                                    SummaVunnen:ndate.results.SummaVunnen
                                 });
                                    this.initiateInterval() 
                                    //  this.setState({done: true})  
                                  
                                  }
     
       // this.setState({done: true})   
    })
}

initiateInterval() {
    clearInterval(this.intervalID);
    this.intervalID= null
    this.intervalID = setInterval(
        () => {
            if(this.state.done === true){            
               // this.setState({done: false}) 
            const userid = this.props.authUser.user_id;
            const Afid = this.props.authUser.user_Afid;
            axios.get(`kontos/DashBoard/getSUMVunnenMonth`,
            { params:encrypt(JSON.stringify({
                Afid:Afid,
                FilterOption:[],
                intervaltype:this.props.intervaltype,
                userid:userid
              }))
            })
            .then(res => {
              if(res.data.success){
                let endata = decrypt(res.data.encryptedData,res.data.iv)
                let ndate = JSON.parse(endata)
                this.setState({ 
                 SummaVunnen:ndate.results.SummaVunnen
              });
                 this.initiateInterval() 
                 //  this.setState({done: true})  
               
               }
             //   this.setState({done: true})   
            })
        }
        },
        180000
    );
    
}


componentWillUnmount() {
  clearInterval(this.intervalID);
  this.intervalID= null
}
componentDidUpdate=()=>{
    const userid = this.props.authUser.user_id;
    const Afid = this.props.authUser.user_Afid;
    if(parseInt(this.props.updatedashboard) === 1){
        axios.get(`kontos/DashBoard/getSUMVunnenMonth`,
    { params:encrypt(JSON.stringify({
        Afid:Afid,
        FilterOption:[],
        intervaltype:this.props.intervaltype,
        userid:userid
      }))
    })
    .then(res => {
      if(res.data.success){
        let endata = decrypt(res.data.encryptedData,res.data.iv)
        let ndate = JSON.parse(endata)
        this.setState({ 
         SummaVunnen:ndate.results.SummaVunnen
      });
         this.initiateInterval() 
         //  this.setState({done: true})  
       
       } 
    })
        this.props.setofUpdatedashboard()
    }

}
DoRotete = (data,ShortStartMonthIndex)=>{
  let i = 0
  while(i < ShortStartMonthIndex){
    data.unshift(data.pop())
    i++
  }
  return data
}
getDashBoardValueOf = ()=>{
  try{
  let ModuleValue = JSON.parse(this.props.DashBoardValueOf).find(item=>parseInt(item.DashBaord) === 1)
  if(ModuleValue.Value > 2 && ModuleValue.Value !== 5){
      return 2
  }else{
      return 1
  }
}
catch(error){return 1}
}

formatNumber=(number)=>{
  const _ValueOF = this.getDashBoardValueOf()
  return NumberFormat(number, _ValueOF === 2?'total':'compact', _ValueOF === 2?'default':'auto', 0)
  return NumberFormat(number, 'compact', 'auto', 0)
  if(number > 1000000){
    return `${(number/1000000).toFixed(0)}M`
}else if(number >= 1000){
    return `${(number/1000).toFixed(0)}K`
}else{
  return isEmpty(number)?0:Number(number).toFixed(0)
}
}
formatNumber2=(number)=>{
console.log(number)
  try{
    const _ValueOF = this.getDashBoardValueOf()
  return NumberFormat(number, _ValueOF === 2?'total':'standard', _ValueOF === 2?'default':'auto', 0)
    return NumberFormat(number.toFixed(0), 'standard', 'auto', 0)
  }catch(error){
    return number
  }
  
}
render() {
  console.log('test83373673', this.props)
  const formatter = new Intl.NumberFormat('fr',{ notation: "compact" , compactDisplay: "short" })
  return (<>{
    this.state.done === false?
    <Skeleton variant="rectangular"  height={100} style={{margin:'auto 10px',backgroundColor:'rgba(38, 9, 72, 0.19)'}}/>
    :
   <div style={{color:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor,margin:"10px", textAlign: 'center'}}>
    <h2 style={{ marginTop: '-5px' }}><IntlMessages id="DashBoard.Total.salling"/> {
         this.props.getIntervalTypeText(this.props.intervaltype).slice(0,parseInt(this.props.intervaltype) === 2?4:3)
        }</h2>
        <h3 style={{ color:  isUndefined(this.props.FontColor)?'#fff':this.props.FontColor, fontSize: this.props.height === 110 ? "2rem" : "3rem",margin:0,fontWeight:"400" }}>
            {this.formatNumber2(this.state.SummaVunnen)}
        </h3>
        
      </div>
}
      </>
  );
}
};

const mapStateToProps = ({ settings,auth,DashBoard,accountsData }) => {
  const { width } = settings;
  const { Flags,updatedashboard,DashBoardValueOf} = accountsData
  const { authUser} = auth;
  const { VunnenChart,VunnenYear,DashboardAnpassadFilterOption,StartMonth} = DashBoard;
  return { width,authUser,VunnenChart,VunnenYear,DashboardAnpassadFilterOption,StartMonth,Flags,updatedashboard,DashBoardValueOf };
};
function mapDispatchToProps(dispatch) {
  return {
    getVunnenChartByUserid: (userid,Afid,DashboardAnpassadFilterOption) => dispatch(getVunnenChartByUserid(userid,Afid,DashboardAnpassadFilterOption)),
    setofUpdatedashboard: () => dispatch(setofUpdatedashboard()),
 
      dispatch
  }
}
export default connect(mapStateToProps,mapDispatchToProps)(ForsaljningThisMonth);
